export default 'Devenir partenaire — Artisan RGE, délégataire, obligé | Solution Éco France';
